import { FC, memo } from 'react';

import PerformanceManagementPresenter from './PerformanceManagementPresenter';

const PerformanceManagement: FC = memo(() => (
  <PerformanceManagementPresenter />
));

export default PerformanceManagement;
